export const ROUTES = {
	DEFAULT: '/',
	START_TOUR: '/startTour',
	FINISHED_TOUR: '/finishTour',
	BOOKING: '/booking',
	BOOKINGS_OVERVIEW: '/bookingsOverview',
	EDIT_BOOKING: '/editBooking',
	OFFICE_INFO_PAGE: '/officeInfo',
	SETTINGS: '/settings',
	BADGE: '/badge',
	DIGITAL_BADGE: '/digitalBadge',
	STATS_AND_BADGES: '/statsAndBadges',
	BADGES: '/badges',
	STATS: '/stats',
	UNLOCK_NOTIFICATION: '/unlock',
	REPORT_SICK_PAGE: '/reportSick',
	COVID_STATUS_PAGE: '/covidStatus',
	PROFILE_PAGE: '/profile',
	LOGIN: '/login',
	CHANGE_LANGUAGE: '/changeLanguage',
	DESK_OVERVIEW: '/office/:officeId/teakEntity/:entityId',
	MEMBER_BADGE: '/member/badge',
	QR_SCANNER: '/qrScanner',
	QUESTIONNER_PAGE: '/questionnaire',
	SHORT_URL_REDIRECT: '/teakEntity/findByIdentifier',
	PRIVACY_POLICY: '/dynamic/privacyPolicy?office',
	REPORT_PROBLEM: '/reportProblem',
	COMMON_AREA_PROBLEM: '/commonAreaProblem',
	FACILITY_PROBLEM: '/facilityProblem',
	REPORT_EMERGENCY: '/reportEmergency',
	EMERGENCY_DETAILS: '/emergencyDetails',
	APP_TECHNICAL_PROBLEM: '/appTechnicalProblem',
	DESK_PROBLEM: '/deskProblem',
	DESK_PROBLEM_DETAILS: '/deskProblemDetails',
	MEETING_ROOM_PROBLEM: '/meetingRoomProblem',
	MEETING_ROOM_PROBLEM_DETAILS: '/meetingRoomProblemDetails',
	REPORT_PROBLEM_QR_SCANNER: '/reportProblemQRScanner',
	OTHER_PROBLEM: '/otherProblem',
	USER_REVIEW: '/userReview',
	REPEAT_BOOKING: '/repeatBooking',
	NO_CERTIFICATE_FOR_CHECKIN: '/noCertificateAddedForCheckin',
	FAVORITES_PAGE: '/favorites',
	VISITOR: {
		NEW_MEETING: '/newMeeting',
		SHOW_ALL: '/showAllVisitors',
		EDIT_VISITOR: '/editVisitor',
		NEW_VISITOR: '/newVisitor',
		ALL_VISITORS: '/allVisitors',
		MEETING_SUMMARY: '/meetingSummary',
		UNSCHEDULED_VISITORS: '/unscheduledVisitors',
	},
	APP_SETTINGS_PAGE: '/appSettingsPage',
	HELP_SETTINGS_PAGE: '/helpSettingsPage',
	LANGUAGE_SETTINGS_PAGE: '/languageSettingsPage',
	BOOKING_SETTINGS_PAGE: '/bookingSettingsPage',
	NOTIFICATION_SETTINGS_PAGE: '/notificationSettingsPage',
	DATA_PRIVACY_SETTINGS_PAGE: '/dataPrivacyPage',
	TIME_TRACKING_SETTINGS_PAGE: '/timeTrackingSettings',
	FAQ_SETTINGS_PAGE: '/faqSettingsPage',
	COLLEAGUE_LIST: '/colleagueList',
	NOTIFICATIONS: '/notifications',
	BOOKING_CONFIRM: '/bookingConfirm',
	SEE_DETAILS_OF_BOOKING: '/bookingDetails',
	OFFICE_SWITCHER: '/officeSwitcher',
	STATISTICS_INFO_PAGE: '/statisticsInfo',
	CHECK_AVAILABILITY: '/checkAvailability',
	MAP_VIEW: '/mapView',
	FIND_COLLEAGUE: '/findColleague',
	SUCCESS_PAYMENT_REDIRECT: '/successPaymentForBooking',
	VERIFY_OTP: '/verifyOTP',
	PROFILE_COMPLETION: '/profile_completion',
	OFFICE_SELECTION: '/office_selection',
	AREA_LIST: '/areaListPage',
	FEATURES_LIST: '/featuresListPage',
	SERVICES_LIST: '/servicesListPage',
	BOOKING_PAGE: '/bookingPage',
	FAVORITES_BOOKING_PAGE: '/favoritesBooking',
	COLLEAGUE_PAGE: '/colleaguePage',
	TEAMS: '/teams',
	SAML: '/saml',
	ERROR_TEAMS_LOGIN: '/errorTeamsLogin',
	REQUEST_FEATURE: '/requestFeature',
	MY_REPORTS: '/myReports',
	REPORT_DETAILS: '/reportDetails',
	ASPEN_LIST: '/aspenItemList',
	ASPEN_BOOKING: '/aspenBooking',
	ASPEN_DETAILS: '/aspenBookingDetails',
	AGENDA: '/agenda',
	ADD_AGENDA_ITEM: '/agendaItem',
	EVENT_INTRO: '/eventIntro',
	EVENT: '/event',
	CGIMETER: '/cgimeter',
	SESSION_DETAILS: '/sessionDetails',
	MEMBER_PROFILE: '/memberProfile',
	EDIT_MEMBER_PROFILE: '/editMemberProfile',
	EVENT_AGENDA: '/eventAgenda',
	EVENT_SUPPORT: '/eventSupport',
	EVENT_SPLASH: '/eventSplash',
	EVENT_ATTENDEES: '/eventAttendees',
	BOOKABLE_SESSION: '/bookableSession',
	OFFICE_ELEMENT: '/oe',
	LEADERSHIP_BOARD: '/leadershipBoard',
	ENTITY_DETAILS: '/entityDetails',
	OWN_ASSETS: '/ownAssets',
	SHARE_ASSET: '/shareAsset',
	TIME_TRACKER:{
		MAIN:'/timeTracker',
		ACTIVITY_EDIT: '/activity/edit',
		ACTIVITY_NEW: '/activity/new'

	}
};
